export enum GridFilterItemType {
	DATE_FROM = 'dateFrom',
	DATE_TO = 'dateTo',
	CREATED_AT = 'createdAt',
	CREATED_STATUS = 'created_status',
	PATIENT_ID = 'patient_id',
	PATIENT_ORIGINAL_ID = 'patient_original_id',
	PATIENT_BIRTH_NUMBER = 'patient_birth_number',
	PATIENT_ID_FROM_ALL_WORKPLACES = 'patient_id_from_all_workplaces',
	DOCTOR_ID = 'doctor_id',
	DOCTOR_ID_FROM_ALL_WORKPLACES = 'doctor_id_from_all_workplaces',
	MEDIC_ID_FROM_ALL_WORKPLACES = 'medic_id_from_all_workplaces',
	DOCTOR_IDS = 'doctor_ids',
	DOCTOR_IDS_NURSE_CASES_CUSTOM = 'doctor_ids_nurse_cases_custom',
	QUESTIONNAIRE_ID = 'questionnaire_id',
	QUESTIONNAIRE_RESULT = 'questionnaire_result',
	QUESTIONNAIRE_SEEN = 'questionnaire_seen',
	QUESTIONNAIRE_CODE = 'questionnaire_code',
	CASE_STATUS = 'case_status',
	WORKPLACES = 'workplaces',
	WORKPLACE = 'workplace',
	CASE_TYPE = 'case_type',
	NCZI_OWN_RECORDS = 'NCZI_own_records',
	NCZI_RECORD_TYPE = 'NCZI_record_type',
	NCZI_SENSITIVITY = 'NCZI_sensitivity',
	WORKPLACE_PATIENT_STATUS = 'workplace_patient_status',
	HEALTH_PLAN_IDS = 'health_plan_ids',
	CASE_PRIORITY = 'case_priority',
	CASE_CREATE_DAY = 'case_create_day',
	CASE_CODE = 'case_code',
	ROOT_CASE_TYPE_CODE = 'root_case_type_code',
	INVOICE_STATE = 'invoice_state',
	ANY_MEDIC_ID = 'any_medic_id',
	SOLVED_AT = 'solved_at',
	FULLTEXT = 'fulltext',
	ROLES = 'ROLES',
	ROLES_WITHOUT_ADMIN = 'ROLES_WITHOUT_ADMIN',
	INSURANCE_COMPANIES = 'INSURANCE_COMPANIES',
	ORDER = 'ORDER',
}
